import * as React from 'react';
import classnames from 'classnames';
import { useSearchBox } from 'react-instantsearch';
import { IconButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { useDispatchTrackEvent } from '@grandvisionhq/svc-tealium/events';
import { useDebouncedEffect } from '@grandvisionhq/utils';

const SearchBox = ({ handleFocus , handleClose , handleSubmit , hasFocus , forceFocus =false ,  })=>{
    const { refine , query: currentRefinement  } = useSearchBox();
    const { getLabel  } = useIntl();
    const inputRef = React.useRef(null);
    const [state, setState] = React.useState(currentRefinement || '');
    const dispatchTrackEvent = useDispatchTrackEvent();
    useDebouncedEffect(()=>{
        return refine === null || refine === void 0 ? void 0 : refine(state);
    }, 200, [
        state
    ]);
    useDebouncedEffect(()=>{
        dispatchTrackEvent(()=>Promise.resolve({
                id: 'Event',
                Events_SearchRun: '1',
                Search_Keyword: state,
                Search_View: 'SERB'
            })
        );
    }, 2000, [
        state
    ]);
    React.useEffect(()=>{
        if (forceFocus) {
            if (inputRef.current) {
                inputRef.current.focus();
            }
            if (document.activeElement !== inputRef.current) {
                handleFocus();
            }
        }
    }, [
        forceFocus
    ]);
    const handleSearch = (event)=>{
        const value = event.currentTarget.value;
        setState(value);
    };
    const onSubmit = ()=>{
        if (currentRefinement && currentRefinement.length >= 2) {
            handleSubmit(currentRefinement, 'products');
        }
    };
    const handleClearInput = ()=>{
        if (refine) {
            refine('');
        }
    };
    const handleKeyUp = (event)=>{
        if (event.key === 'Enter') {
            onSubmit();
        }
    };
    const handleBlur = (e)=>{
        const target = e === null || e === void 0 ? void 0 : e.relatedTarget;
        const excludedItemClicked = target && target instanceof HTMLElement && [
            'a',
            'button'
        ].includes(target.tagName.toLowerCase());
        if (!currentRefinement && !excludedItemClicked) {
            handleClose();
        }
    };
    const searchBoxClass = classnames('search-box', {
        'search-box--focus': hasFocus
    });
    const inputClass = classnames('search-box__input', {
        'search-box__input--focus': hasFocus
    });
    const searchIconClass = classnames('search-box-icons__search', {
        'search-box-icons__search--active': currentRefinement && currentRefinement.length > 0,
        'search-box-icons__search--focus': hasFocus
    });
    const clearInputClass = classnames('search-box-icons__clear', {
        'search-box-icons__clear--active': currentRefinement && currentRefinement.length > 0
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: searchBoxClass
    }, /*#__PURE__*/ React.createElement("input", {
        className: inputClass,
        type: "search",
        onBlur: handleBlur,
        onFocus: handleFocus,
        onSubmit: onSubmit,
        onChange: handleSearch,
        onKeyUp: handleKeyUp,
        placeholder: getLabel('search.searchField.placeholder'),
        value: state,
        ref: inputRef,
        "data-t": "search-box"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "search-box-icons"
    }, /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('common.actions.search'),
        className: searchIconClass,
        onClick: onSubmit,
        type: "submit"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "search"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "search-box-icons__actions"
    }, /*#__PURE__*/ React.createElement("button", {
        className: clearInputClass,
        onClick: handleClearInput
    }, getLabel('search.searchField.clear')), /*#__PURE__*/ React.createElement(IconButton, {
        className: "search-box-icons__close",
        "aria-label": getLabel('common.actions.close'),
        onClick: handleClose
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "close"
    })))));
};

export { SearchBox, SearchBox as default };
//# sourceMappingURL=SearchBox.js.map
